import React, { useState } from "react";
import { Helmet } from "react-helmet";
import GenerateHomePageLinks from "../HomePageLinks/HomePageLinks";
import { MASTER_JOB_LABELS } from "../config/masterJobsApi";

const answerKeyTips = [
  "Compare the official answer key with your attempted answers carefully.",
  "Check whether objections or challenge windows are open.",
  "Use answer keys to understand mistakes and improve future preparation.",
];

const AnswerKeyPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="page-container">
      <Helmet>
        <title>{`Free Answer Key Updates ${new Date().getFullYear()} | AAMSchool`}</title>
        <link rel="canonical" href="https://www.aamschool.in/answer-key" />
        <meta
          name="description"
          content="Read free answer key updates, objection notices, and exam review related alerts on AAMSchool."
        />
        <meta property="og:title" content={`Free Answer Key Updates ${new Date().getFullYear()} | AAMSchool`} />
        <meta
          property="og:description"
          content="Read free answer key updates, objection notices, and exam review related alerts on AAMSchool."
        />
        <meta property="og:url" content="https://www.aamschool.in/answer-key" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Answer Key {new Date().getFullYear()}</h1>
      <p className="page-lead">
        Answer key updates help candidates estimate performance before final results are published.
        This page is intended to make those updates easier to find and to support exam analysis
        after the test.
      </p>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search jobs, admit card, result..."
          className="global-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <GenerateHomePageLinks
        label={MASTER_JOB_LABELS.answerKeys}
        header="Latest Answer Keys"
        searchTerm={searchTerm}
        showAllItems
        layoutVariant="page"
      />

      <section className="page-info-grid" aria-label="Answer key guidance">
        <article className="page-info-card">
          <h2>How To Review An Answer Key</h2>
          <ul className="page-info-list">
            {answerKeyTips.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="page-info-card">
          <h2>Use It For Learning</h2>
          <p>
            An answer key is not only for score estimation. It also helps candidates identify weak
            topics, review question patterns, and plan revision before the next exam cycle.
          </p>
        </article>
      </section>
    </div>
  );
};

export default AnswerKeyPage;
